const publicCart = {
    // namespaced: true,
    state: {
        publicCartItems: [],
    },
    mutations: {
        ADD_TO_CART(state, productToAdd) {
            if (!productToAdd || !productToAdd.bundleId) {
                return;
            }

            const existingBundleIdIndex = state.publicCartItems.findIndex(
                (product) => product.bundleId === productToAdd.bundleId
            );

            if (existingBundleIdIndex > -1) {
                return;
            }

            const currentPrice = productToAdd.onSale ? productToAdd.salePrice : productToAdd.price;
            state.publicCartItems.push({ ...productToAdd, quantity: 1, currentPrice });
        },
        DELETE_FROM_CART(state, productBundleIdToRemove) {
            state.publicCartItems = state.publicCartItems.filter(({ bundleId }) => bundleId !== productBundleIdToRemove);
        },
        UPDATE_PRODUCT(state, updatedProduct) {
            state.publicCartItems = state.publicCartItems.map((product) => {
                if (product.bundleId === updatedProduct.bundleId) {
                    return updatedProduct;
                }

                return product;
            });
        },
        SET_PUBLIC_CART_ITEMS(state, cartItems){
            state.publicCartItems = cartItems;
        }
    },
    actions: {
        addToPublicCart({ commit }, product) {
            commit("ADD_TO_CART", product);
        },
        removeFromPublicCart({ commit }, bundleIdToRemove) {
            commit("DELETE_FROM_CART", bundleIdToRemove);
        },
        updatePublicCartProduct({ commit }, updatedProduct) {
            commit("UPDATE_PRODUCT", updatedProduct);
        },
        setPublicCartItems({ commit }, cartItems) {
            commit("SET_PUBLIC_CART_ITEMS", cartItems);
        },
    },
    getters: {
        getPublicCartItems(state) {
            return state.publicCartItems;
        },
        getPublicCartItemsLength(state) {
            return state.publicCartItems.length;
        },
    },
};

export default publicCart;
